import { getDataKeys } from "shelving";
import { Page } from "shared/react";
import { MEMBERS_MAX, MEMBER_APPROVED_STATUS } from "shared/schema";
import { USER } from "../util/user.js";
import { MemberGroupList } from "./GroupList.js";
import { GroupsNavigation } from "./GroupsNavigation.js";

export function GroupsPage(): React.ReactElement {
	return (
		<Page title="Groups">
			<GroupsNavigation>
				<h1>Groups</h1>
			</GroupsNavigation>
			<section>
				<MemberGroupList //
					query={{
						uid: USER.data.uid,
						status: getDataKeys(MEMBER_APPROVED_STATUS),
						$order: "!updated",
						$limit: MEMBERS_MAX,
					}}
				/>
			</section>
		</Page>
	);
}
